/**
 * element 文档地址：https://element.eleme.cn/#/zh-CN/component/form
 */

import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import 'echarts'
import VueECharts from 'vue-echarts'
import {
  CustomizeButton,
  CustomizeForm,
  CustomizeFormInfo,
} from '@/components/customize'
import TableView from '@/components/table-view/table-view'
import MultiFileUpload from 'components/multi-file-upload/multi-file-upload'
import storage from '@/utils/storage'
import { cloneDeep } from 'lodash/lang'
import utils from '@/utils/util'
import dayjs from 'dayjs'

Vue.component('v-chart', VueECharts)
Vue.component('customize-button', CustomizeButton)
Vue.component('customize-form', CustomizeForm)
Vue.component('customize-form-info', CustomizeFormInfo)
Vue.component('table-view', TableView)
Vue.component('multi-file-upload', MultiFileUpload)

Vue.use(ElementUI, { locale })
Vue.use(dayjs)

Vue.prototype.$storage = storage
Vue.prototype.$cloneDeep = cloneDeep
Vue.prototype.$utils = utils
Vue.prototype.$dayjs = dayjs

// 全局过滤器
Vue.filter('formatAmount', value => {
  return utils.formatAmount(value)
})
Vue.filter('formatAmount1', value => {
  return utils.formatAmount1(value)
})
